import { render, staticRenderFns } from "./create.vue?vue&type=template&id=456391b9&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=456391b9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456391b9",
  null
  
)

export default component.exports